import Amount from "@/models/Shared/Amount";

export default class BuySellFXRequest {
    buySellDirection: string = "";
    sourceWalletId: string = "";
    destinationWalletId: string = "";
    sourceAmount: Amount = new Amount();
    destinationAmount: Amount = new Amount();
    feeAmount: Amount = new Amount();
    buyCurrency: string = "";
    sellCurrency: string = "";
    newWalletTypeCode: string = "";
    newWalletTypeName: string = "";
    acceptedQuote: boolean = false;
}